<div class="card">
  <ng-container *ngTemplateOutlet="headerContentTemplate"></ng-container>
  <div
    class="flex justify-content-between flex-column-reverse md:flex-row align-items-center"
  >
    <div class="w-4">
      <div
        class="text-xl text-900 mb-4 mt-4 md:mt-0 text-center md:text-left font-semibold md:pr-4"
      >
        {{ title() }}
      </div>
      @if (description()) {
      <div
        class="flex flex-wrap justify-content-center md:justify-content-start gap-3"
      >
        <p>{{ description() }}</p>
      </div>
      }
    </div>
    <div
      class="flex flex-row align-items-center justify-content-end w-8"
      *ngIf="rightTopContent || rightTopContentTemplate"
    >
      <ng-container *ngTemplateOutlet="rightTopContentTemplate"></ng-container>
    </div>
  </div>
  <br />
  <ng-content></ng-content>
  <ng-container *ngTemplateOutlet="bottomContentTemplate"></ng-container>
</div>
